//import logo from './logo.svg';
import './App.css';

import { useState } from 'react';

import { BrowserRouter, Route, Routes } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css' 

import Test from './Test';

import CountProductos from './Rutas/CountProductos'

import AllProducts from './Rutas/AllProducts';


import { Menu } from '@mui/material';
import Header from './Rutas/Header/Header';
import Carousel01 from './Rutas/Carousel/Carousel01';
import ExcelLoad from './Rutas/Excel/ExcelLoad';
import ShowFull from './Rutas/Showproduct/ShowFull';
//import SideBar from './Rutas/SideBar/SideBar';



// https://snapon.com.mx/wp-content/uploads/2020/12/logo-snap-on-2x-1.png
// Esta es una prueba

function App() {

  const [showProduct,setShowProduct] = useState( { status : false}) ; // Solo para visualizar el producto  

  function setClose()
  {
    // Do something


    setShowProduct( {status:false}) ;



  }



  return (


    <div>

      {/* <ExcelLoad></ExcelLoad> */}
       <Header show={setShowProduct} ></Header>
      <div style={{overflowy:'scroll'}}>
        <div className='m-4'></div>

        { !showProduct.status && (
          <div className='pt-0 pb-5'>
            <Carousel01 show={setShowProduct}></Carousel01>
          </div>
          )
        }


        { showProduct.status && ( <ShowFull className='px-5' show={showProduct} disable={setShowProduct} setClose={setClose}></ShowFull> )}

      </div>
     
      
    
    </div>


  );
}

export default App;
